import { forwardRef } from 'react';

/**
 * A link that carries the Etch link treatment (underline, brand colour).
 * Polymorphic via `as` so it can render a plain `<a>`, a router `<Link>`
 * (e.g. `as={RouterLink}` from react-router-dom), or a `<button>` when it
 * needs to behave like a link but trigger a handler instead of navigating.
 *
 * @param {object} props
 * @param {import('react').ElementType} [props.as='a']
 * @param {string} [props.className]
 */
export const Link = forwardRef(function Link({ as: Component = 'a', className = '', children, ...rest }, ref) {
  return (
    <Component ref={ref} className={`etch-link ${className}`.trim()} {...rest}>
      {children}
    </Component>
  );
});

export default Link;
